import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'searchV2',
		path: '/search/v2',
		component: loadable(async () => import(/* webpackChunkName: "pages/searchV2" */ './index'), {
			exportName: 'SearchV2',
			fallback: Loading,
		}),
		frame: true,
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
